<div mat-dialog-header>
  @if (!lookupMode) {
    <h1>Compare Products</h1>
  } @else {
    <h1>Lookup Product</h1>
  }
</div>
<mat-dialog-content #scroll class="dialog-container">
  @if (!lookupMode) {
    <div class="row compare-container col-12">
      @for (t of tables; track t) {
        <kendo-grid
          #grid
          class="compare-table w-100"
          [kendoGridBinding]="t.gridData"
          [sortable]="t.type === 'horz'"
          [resizable]="true"
          [style.maxHeight.pct]="90"
          [navigable]="true"
        >
          @if (t.type !== 'horz') {
            <kendo-grid-column
              field="metric"
              title=""
              width="105"
              [locked]="true"
            />
          }
          @if (t.type !== 'horz') {
            @for (column of t.columns; track column; let i = $index) {
              <kendo-grid-column
                field="{{ column.id }}"
                title="{{ column.name }}"
                [width]="300"
              >
                <ng-template let-dataItem kendoGridCellTemplate>
                  <span>{{ dataItem[column.id] }}</span>
                </ng-template>
              </kendo-grid-column>
            }
          }
          @if (t.type === 'horz') {
            @for (column of t.columns; track column) {
              <kendo-grid-column
                field="{{ column.id }}"
                title="{{ column.name }}"
                [width]="column.id === 'name' ? 250 : 150"
                [locked]="column.id === 'name'"
              />
            }
          }
        </kendo-grid>
        @if (t.footer && t.footer.footnotes) {
          @for (z of t.footer.footnotes; track z) {
            <p class="small">{{ z }}</p>
          }
        }
      }
    </div>
  }
  @if (lookupMode) {
    <div
      ><app-product-shelf-compare-lookup
        (compareTemplateData)="addTemplateData($event)"
    /></div>
  }
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  @if (!lookupMode) {
    @if (canLookup) {
      <button mat-raised-button color="primary" (click)="triggerLookup()"
        >Select Existing Product (Beacon)</button
      >
    }
    <button
      mat-stroked-button
      color="primary"
      (click)="downloadComparisonPdf()"
    >
      <mat-icon>download</mat-icon>Download Comparison
    </button>
  } @else if (lookupMode) {
    <button mat-button color="warn" (click)="exitLookup()"
      >Cancel Lookup</button
    >
  }
  <button mat-raised-button (click)="dialogRef.close('Cancel')">Close</button>
</mat-dialog-actions>
<ngx-loading
  [show]="loading"
  [config]="{
    fullScreenBackdrop: true,
    backdropBackgroundColour: 'rgba(0,0,0,.5)',
  }"
/>
